// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueFire from 'vuefire'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import numeral from 'numeral'
import PulseLoader from 'vue-spinner/src/PulseLoader'

Vue.config.productionTip = false

const ProductCode = {
  getRoofs () {
    return {
      'Polycarbonate': '',
      'Polycarbonate Clear': 'PC',
      'Polycarbonate Opal': 'PO',
      'Polycarbonate Bronze': 'PB',
      'Polycarbonate Bronze/Opal': 'PBO',
      'Tile Effect Black': 'TB',
      'Tile Effect Terracotta Red': 'TR',
      'Tile Effect Grey': 'TG',
      'Leka Tiled Black': 'LTB',
      'Leka Tiled Green': 'LTG',
      'Leka Tiled Red': 'LTR',
      'Leka Tiled Grey': 'LTGR',
      'Leka Tiled Pewter': 'LTP',
      'Leka EPDM Insulated Roof System': 'LEPDM'
    }
  },
  getColours () {
    return {
      'White': '',
      'Rosewood': 'R',
      'Golden Oak': 'GO',
      'Black': 'B',
      'Grey': 'GY',
      'Green': 'GN',
      'Rainbow': 'RB'
    }
  },
  getRoof (product) {
    if (product.roof) {
      return product.roof.prefix
    } else {
      // alert('Please re-select your roof')
    }
  },
  getColour (product) {
    if (product.colour) {
      return product.colour.prefix ? product.colour.prefix : ''
    } else {
      // alert('Please re-select your colour')
    }
  },
  generate (product) {
    let bits = [product._family.prefix, product.variation, this.getRoof(product), this.getColour(product)]
    bits = bits.filter((bit) => {
      return bit && bit.length && bit.length > 0
    })
    return bits.join('-')
  }
}

ProductCode.install = () => {
  Object.defineProperty(Vue.prototype, '$productCode', {
    get () {
      return ProductCode
    }
  })
}

Vue.use(ProductCode)
Vue.use(BootstrapVue)
Vue.use(VueFire)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.component('icon', Icon)

import { fb } from './firebase'

window.fb = fb

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App,
    PulseLoader
  },
  render (h) {
    return h(App, {
      props: {
        fb: fb
      }
    })
  },
  filters: {
    currency (value) {
      return numeral(value).format('0,0')
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js